import { isOverlayPath } from 'lib/paths'
import type { ChatPreviewFeed, WallPreviewFeed } from 'components/overlayPreview/previewFeeds'

declare const SEAM_BRAND: unique symbol

export type PreviewMode = 'live' | 'mockup'

export interface OverlayPreviewSeam {
  readonly [SEAM_BRAND]: true
  readonly mode: PreviewMode
  readonly chatFeed: ChatPreviewFeed | null
  readonly wallFeed: WallPreviewFeed | null
  readonly seed: number
}

const MINTED = new WeakSet<object>()

export const mintPreviewSeam = (fields: {
  mode: PreviewMode
  chatFeed: ChatPreviewFeed | null
  wallFeed: WallPreviewFeed | null
  seed: number
}): OverlayPreviewSeam => {
  const seam = Object.freeze({
    mode: fields.mode,
    chatFeed: fields.chatFeed,
    wallFeed: fields.wallFeed,
    seed: fields.seed
  })
  MINTED.add(seam)
  return seam as unknown as OverlayPreviewSeam
}

export const onOverlayPagePath = (pathname: string): boolean => {
  if (isOverlayPath(pathname)) return true
  let decoded = pathname
  try {
    decoded = decodeURI(pathname)
  } catch {
    return true
  }
  return isOverlayPath(decoded.replace(/\/{2,}/g, '/').toLowerCase())
}

export const previewSeamActive = (seam: unknown): seam is OverlayPreviewSeam => {
  if (typeof seam !== 'object' || seam == null) return false
  if (!MINTED.has(seam)) return false
  if (typeof globalThis.location === 'undefined' || globalThis.location == null) return false
  const pathname = globalThis.location.pathname
  if (typeof pathname !== 'string') return false
  return !onOverlayPagePath(pathname)
}
